import { render, staticRenderFns } from "./ProductOrderAdd.vue?vue&type=template&id=32fac7d2&scoped=true&"
import script from "./ProductOrderAdd.vue?vue&type=script&lang=js&"
export * from "./ProductOrderAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrderAdd.vue?vue&type=style&index=0&id=32fac7d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fac7d2",
  null
  
)

export default component.exports